import { render } from "./SummarySection.vue?vue&type=template&id=364e191f&ts=true"
import script from "./SummarySection.vue?vue&type=script&lang=ts"
export * from "./SummarySection.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__